import React from 'react';
import Chart from './Chart';

const PieChart = (props) => <Chart type="pie" {...props} />;

export default PieChart;
